import specialSyntax from "../../constants/specialSyntax";

const WINDOWS_KEY_LABEL_CONTROL = "Ctrl";
const WINDOWS_KEY_LABEL_ALTERNATIVE = "Alt";
const WINDOWS_KEY_LABEL_WIN = "Win";
const WINDOWS_KEY_LABEL_SHIFT = "Shift";
const KEY_ARROW_DOWN = specialSyntax.ARROW_DOWN;
const KEY_ARROW_UP = specialSyntax.ARROW_UP;

const MAC_KEY_LABEL_COMMAND = "⌘";
const MAC_KEY_LABEL_SHIFT = "⇧";
const MAC_KEY_LABEL_OPTION = "⌥";

const keyStringToHotKey = {
  ctrl: "ctrl",
  alt: "alt",
  win: "win",
  shift: "shift",
  [KEY_ARROW_DOWN]: "down",
  [KEY_ARROW_UP]: "up"
};

export {
  KEY_ARROW_DOWN,
  KEY_ARROW_UP,
  keyStringToHotKey,
  MAC_KEY_LABEL_COMMAND,
  MAC_KEY_LABEL_OPTION,
  MAC_KEY_LABEL_SHIFT,
  WINDOWS_KEY_LABEL_ALTERNATIVE,
  WINDOWS_KEY_LABEL_CONTROL,
  WINDOWS_KEY_LABEL_SHIFT,
  WINDOWS_KEY_LABEL_WIN
};
